import BackLink from './BackLink.component';

export default BackLink;
